import { gql } from '@apollo/client';

export const GET_USED_ETHEREUM_ADDRESSES = gql`
  query GetUsedEthereumAddresses($address: String!) {
    getUsedEthereumAddresses(address: $address)
  }
`;
